export default __webpack_public_path__ + "static/media/appStore.8c4986ee.svg";